import React from 'react';
import AskTurn from './AskTurn';
import AskComposer from './AskComposer';
import ScopeBar from './ScopeBar';
import { ASK_COPY, EXAMPLE_QUESTIONS } from '../../utils/askScope';

// The conversation: scope bar on top, a scrolling log of turns, the composer docked below.
// Pure props. `thread` is utils/askThread's `{ threadId, turns }`; `scope` is
// utils/askScope.scopeSummary(rows, source). The empty state shows example questions and the
// capture-path note. Handlers: onSend(text) (composer), onAsk(text) (chips), onCancel(),
// onRetry(text), onJump(rowRef, turn), isRowLive(rowRef, turn) (the turn is passed
// because a rowRef indexes the rows THAT question ran over), renderExtra(turn) -> node
// (optional slot under the answer for the older rungs' tables).
export default function AskThread({
  thread, scope, onSend, onAsk, onCancel, onRetry, onJump, isRowLive, depthControl, renderExtra, composerInitialText,
}) {
  const turns = thread && Array.isArray(thread.turns) ? thread.turns.filter((t) => t && typeof t === 'object') : [];
  const working = turns.some((t) => t.status === 'working');
  return (
    <section className="ask-thread" aria-label="Ask">
      <ScopeBar summary={scope} />
      <div className="ask-log" role="log" aria-live="polite">
        {turns.length === 0 ? (
          <div className="ask-empty">
            <p className="ask-muted-note">{ASK_COPY.captureNote}</p>
            <div className="ask-examples">
              {EXAMPLE_QUESTIONS.map((q) => (
                <button key={q} type="button" className="ask-example" disabled={working} onClick={() => onAsk && onAsk(q)}>{q}</button>
              ))}
            </div>
          </div>
        ) : turns.map((t, i) => (
          <AskTurn
            key={t.id || i}
            turn={t}
            busy={working}
            onAsk={onAsk}
            onRetry={onRetry}
            onJump={typeof onJump === 'function' ? (ref, ev) => onJump(ref, t, ev) : undefined}
            isRowLive={typeof isRowLive === 'function' ? (ref, ev) => isRowLive(ref, t, ev) : undefined}
            renderExtra={renderExtra}
          />
        ))}
      </div>
      <AskComposer onSend={onSend} onCancel={onCancel} working={working} depthControl={depthControl} initialText={composerInitialText} />
    </section>
  );
}
